import { z } from 'zod';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const ExecutionItemBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  expenditureCartId: z.string().uuid(),
  name: z.string().min(1),
  amount: z.number(),
});

export const ExecutionItemModel = ExecutionItemBaseModel;

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const UpsertPriorExecutionItemFormSchema = z.object({
  amount: z.number().nullable(),
  expenditureCartId: z.string().uuid(),
});
